var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',[_c('a-spin')],1):_vm._e(),(!_vm.isLoading)?_c('div',_vm._l((_vm.tasksOrdered),function(task){return _c('div',{key:task.id,staticClass:"task"},[_c('b',[_vm._v(_vm._s(task['displayName']))]),_c('div',[_vm._v(" "+_vm._s(task['description'])+" ")])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }